import { TILE_PX } from './viewport.ts';

export const RALLYXY_SPRITE_URL = `${import.meta.env.BASE_URL}assets/rallyxy-sprites.png`;

const SPRITE_NAMES = [
  'player_car_n',
  'player_car_e',
  'player_car_s',
  'player_car_w',
  'enemy_car_n',
  'enemy_car_e',
  'enemy_car_s',
  'enemy_car_w',
  'player_car_ne',
  'player_car_se',
  'player_car_sw',
  'player_car_nw',
  'enemy_car_ne',
  'enemy_car_se',
  'enemy_car_sw',
  'enemy_car_nw',
  'smoke_screen',
  'flag',
  'street',
  'grass',
  'blocked_road',
] as const;

export type SpriteName = (typeof SPRITE_NAMES)[number];

export type SpriteFrame = {
  readonly x: number;
  readonly y: number;
  readonly w: number;
  readonly h: number;
};

export type SpriteSheet = {
  readonly image: CanvasImageSource;
  readonly frames: Readonly<Record<SpriteName, SpriteFrame>>;
};

export const RALLYXY_SPRITE_FRAMES: Readonly<Record<SpriteName, SpriteFrame>> = Object.fromEntries(
  SPRITE_NAMES.map((name, i) => [
    name,
    {
      x: (i % 5) * TILE_PX,
      y: Math.floor(i / 5) * TILE_PX,
      w: TILE_PX,
      h: TILE_PX,
    },
  ]),
) as Readonly<Record<SpriteName, SpriteFrame>>;

export function createRallySpriteSheet(image: CanvasImageSource): SpriteSheet {
  return { image, frames: RALLYXY_SPRITE_FRAMES };
}

export function drawSprite(
  ctx: CanvasRenderingContext2D,
  sheet: SpriteSheet,
  name: SpriteName,
  dx: number,
  dy: number,
  dw = TILE_PX,
  dh = TILE_PX,
): void {
  const frame = sheet.frames[name];
  ctx.drawImage(sheet.image, frame.x, frame.y, frame.w, frame.h, dx, dy, dw, dh);
}
